import './App.css';
import { Col, Grid, Row, Typography, Button} from 'antd';
import { useEffect } from "react";
import ContactsBanner from './img/ContactsBanner.jpg';
import HomePageImgFamilyOneWeb from './img/HomePageImgFamilyOneWeb.png';
import HomePageImgEnterpriseOneWeb from './img/HomePageImgEnterpriseOneWeb.png';
import AmberFinLogo from './img/AmberFinLogo.png';
import { NavLink } from "react-router-dom";

const { Title, Text } = Typography;

function Products() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
  return (
        <>
            <Row 
            className={'page-row'}
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto',
                textAlign: "center"
            }}>
                <Col span={24}>
                    <Title level={1}>We buil the products we use</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>
                        Amber IT helps you develop, infrastreucture, and QA smarter. Welcome to your new <br />favourite way to do all things IT.</Title>
                    <br />
                    <NavLink className={"menu"} to={'/contacts'}>
                        <Button 
                            size="large"
                            variant='solid'
                            color="default" 
                            style={{marginBottom: 48}}>
                                Contact sales
                        </Button>
                    </NavLink>
                </Col>
            </Row>
            
            <Row 
            className={'page-row'}
            style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto'
            }}
            gutter={[0, 16]}>
                <Col
                    xs={24} md={8}
                    style={{padding: "0 8px"}}
                >
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgEnterpriseOneWeb})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: "440px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>ERP Systems </h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary">
                                <img src={AmberFinLogo} style={{ maxWidth: '18px' }} alt={'Amber IT Logo'} />
                            </Text>
                        </div>
                        <NavLink className={"menu"} to={'/contacts'}>
                            <Button
                                size="samll"
                                variant='solid'
                                color="default"
                                style={{margin: '248px auto 0 auto', display: 'block'}}>
                                    Contact sales
                            </Button>
                        </NavLink>

                    </div>
                </Col>
                <Col xs={24} md={8} style={{padding: "0 8px"}}>
                    <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                        backgroundPosition: 'right',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: "440px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Housing Sofrware</h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary">
                                <img src={AmberFinLogo} style={{ maxWidth: '18px' }} alt={'Amber IT Logo'} />
                            </Text>
                        </div>
                        
                        <NavLink className={"menu"} to={'/contacts'}>
                            <Button
                                size="samll"
                                variant='solid'
                                color="default"
                                style={{margin: '248px auto 0 auto', display: 'block'}}>
                                    Contact sales
                            </Button>
                        </NavLink>
                    </div>
                </Col>
                <Col 
                    xs={24} md={8} 
                    style={{padding: "0 8px"}}
                >
                <div style={{
                        borderRadius: 24,
                        backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                        backgroundPosition: 'left',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        height: "440px",
                        position: "relative",
                    }}>
                        <br />
                        <div style={{
                            borderRadius: 12,
                            backgroundColor: "#fff",
                            margin: "16px 32px",
                            padding: "8px 24px"
                        }}>
                            <h1 style={{ fontSize: 18, display: "inline-block" }}>Banking Systems</h1>
                            <Text style={{float: "right", paddingTop: 8}} type="secondary">
                                <img src={AmberFinLogo} style={{ maxWidth: '18px' }} alt={'Amber IT Logo'} />
                            </Text>
                        </div>
                        <NavLink className={"menu"} to={'/contacts'}>
                            <Button
                                size="samll"
                                variant='solid'
                                color="default"
                                style={{margin: '248px auto 0 auto', display: 'block'}}>
                                    Contact sales
                            </Button>
                        </NavLink>
                    </div>
                    </Col>
            </Row>
            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: '24px auto 96px auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>
                    <Title level={1} style={{marginTop: isMobile ? 48 : 128}}>IT Products done right</Title>
                    <Title level={4} style={{fontWeight: "normal"}}>Engineering IT products that meet business, security and regulatory demands — designed for <br/>performance, resilience and seamless integration</Title>
                </Col>
            </Row>

            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: isMobile ? '48px auto 0 auto' : '126px auto 0 auto',
                textAlign: "center"
            }}>
                                   

                <Col span={24}>

                    <p>We operate as a trusted technology partner — committed to long-term collaboration, clear accountability and delivering measurable outcomes.</p>
                    <br />
                    <p style={{ textAlign: "right", fontSize: 10 }} className={"amber-title-color"}>
                        <strong>AMBER</strong>TECHNOLOGIES
                    </p>
                </Col>
            </Row>
        </>
    );
}

export default Products;
